import axios from 'axios';
import { getAccessToken } from '../../../accessToken';

const token = getAccessToken();

const instanciaAxios = axios.create({
  headers: {
    'Content-Type': 'application/json',
    Authorization: token,
  },
});

const get = async ({ params }) => {
  return await instanciaAxios.get(`${process.env.VUE_APP_API_REST}/api/v1/esam/proyeccion/sedes`, { params });
};

export default { get };
